const guard = {
    invalid_input: 'Die Anfrage {{type}} ist ungültig.',
    invalid_pagination: 'Die Paginierung der Anfrage ist ungültig.',
    can_not_get_tenant_id: 'Die tenant_id konnte nicht aus der Anfrage abgerufen werden.',
    file_size_exceeded: 'Dateigröße überschritten.',
    mime_type_not_allowed: 'Der MIME-Typ ist nicht erlaubt.',
};
export default guard;
